export enum CareerStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published',
  UNPUBLISHED = 'unpublished',
}

export interface Career {
  _id: string;
  title: string;
  slug: string;
  department: string;
  location: string;
  employmentType: string;
  description: string;
  requirements: string[];
  responsibilities: string[];
  salary?: string;
  benefits?: string[];
  applicationDeadline?: string;
  redirectLink?: string;
  status: CareerStatus;
  priority: number;
  tags: string[];
  metaTitle?: string;
  metaDescription?: string;
  author: {
    _id: string;
    firstName: string;
    lastName: string;
    email?: string;
  };
  publishedAt?: string;
  views: number;
  applications: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateCareerDto {
  title: string;
  slug?: string;
  department: string;
  location: string;
  employmentType: string;
  description: string;
  requirements: string[];
  responsibilities: string[];
  salary?: string;
  benefits?: string[];
  applicationDeadline?: string;
  redirectLink?: string;
  status?: CareerStatus;
  priority?: number;
  tags?: string[];
  metaTitle?: string;
  metaDescription?: string;
}

export interface UpdateCareerDto extends Partial<CreateCareerDto> { }

export interface CareerListResponse {
  careers: Career[];
  total: number;
  totalPages: number;
}

export interface CareerStats {
  total: number;
  published: number;
  draft: number;
  unpublished: number;
  totalViews: number;
  totalApplications: number;
} 